import { useState, useRef, useEffect } from 'react';
import { gameDrawer } from './GameDrawer';
import { GAME_APPLICATION_SCENE_STATE, GAME_APPLICATION_TYPE_STATE } from '../stateManagment';

export const useGameContext = () => {
  const [parent, setParent] = useState(gameDrawer.parent);
  const [scene, setScene] = useState(GAME_APPLICATION_SCENE_STATE.getValue());
  const [mode, setMode] = useState(GAME_APPLICATION_TYPE_STATE.getValue());
  const oldScene = useRef(null);

  useEffect(() => {
    const gameApplicationSceneStateObserver = GAME_APPLICATION_SCENE_STATE.subscribe((s, { prev }) => {
      oldScene.current = prev;
      setScene(s);
    });
    const gameApplicationTypeStateObserver = GAME_APPLICATION_TYPE_STATE.subscribe(setMode);
    return () => {
      gameApplicationSceneStateObserver.unsubscribe();
      gameApplicationTypeStateObserver.unsubscribe();
    };
  }, []);


  return { parent, mode, scene, prevScene: oldScene.current };
};
